exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nos-selector-container{margin-bottom:10px}.nos-selector-container .nos-selector{width:300px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/search/FormElements/nosSelector/nos-selector.less
 ** module id = 1082
 ** module chunks = 0
 **/